// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oy-c";
export var backButton = "_oy-4";
export var backIcon = "_oy-5";
export var chevronShortcut = "_oy-6";
export var container = "_oy-1";
export var editor = "_oy-8";
export var editorWrapper = "_oy-7";
export var prefix = "_oy-2";
export var searchIcon = "_oy-3";
export var suffix = "_oy-9";
export var suffixContent = "_oy-a";
export var suffixText = "_oy-b";
export var wrapper = "_oy-0";